import { Action } from 'redux'
import { createActions, createReducer } from 'reduxsauce'

import {
	IActionsFromCreators,
	ISubscriptionActionCreators
} from '../../interfaces/action'
import { ISubscription } from '../../interfaces/subscriptions'


/**
 * Action types & creators
 */
export const {
	Types,
	Creators
}: IActionsFromCreators<ISubscriptionActionCreators> =
	createActions({
		setAllExistingActiveSubscriptions: ['allExistingActiveSubscriptions']
	})

/**
 * Handlers
 */
export const INITIAL_STATE: ISubscription[] = []

const set = (state = INITIAL_STATE, action: any) => {
	return { ...state, ...action.allExistingActiveSubscriptions }
}

/**
 * Reducer
 */
export default createReducer<
	ISubscription[],
	Action<ISubscriptionActionCreators>
>(INITIAL_STATE, {
	[Types.SET_ALL_EXISTING_ACTIVE_SUBSCRIPTIONS]: set
})
